const contracts = {
    usdt: {
        56: '',
        97: '0x8EBe3706fceE695fA006622416C24728d46d34bB',
        type: 1
    },
    eth: {
        56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
        97: '0xea6838c9e17ed7334682dF1d96A7852cCE370eFe',
        type: 4
    },
    btc: {
        56: '',
        97: '0xEf69eFfd3dA25c5F6590366320B751966506Af4d',
        type: 3
    },
    busd: {
        56: '',
        97: '0xF188Fcd3e22FA9C3204A285b7bbAb4F3cB8b9c00',
        type: 5
    },
    crowdsale: {
        56: '',
        97: '0xC067B4Cc56e5Fb2Bb285587ea4c5f2F20d2C3dd3',
    },
    bnb: {
        56: '',
        97: '0x3dC969295b2bF20603523bDB0f510A4B1BA95275',
        type: 2
    },
    eqx: {
        56: '',
        97: '0xF768C1253A7321Cd449Af066708eFFD9A852618b'
    }
}

export default contracts